<template>
  <div v-if="isVisible" class="draft-profile-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h5 class="mb-0">
          <icon icon="fa-solid fa-triangle-exclamation" class="text-warning me-2" />
          Cập nhật hồ sơ
        </h5>
        <button class="btn-close-popup" @click="closePopup" title="Đóng">
          <icon icon="fa-solid fa-xmark" />
        </button>
      </div>
      <div class="popup-body">
        <p class="text-muted fs-7 mb-3">Tài khoản của bạn vừa được tạo qua Google. Vui lòng cập nhật đầy đủ thông tin (Họ tên, tên đăng nhập, tuổi, mật khẩu) để trải nghiệm tốt nhất.</p>
        <button class="btn btn-book-primary w-100 py-2 fs-7" @click="goToUpdate">
          Cập nhật ngay
        </button>
      </div>
    </div>
  </div>
</template>

<script src="./DraftProfilePopup.js"></script>
<style scoped src="./DraftProfilePopup.css"></style>
